<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="rabb" title="List of Abbreviations">
<div class="hide"> </div>
<div class="hide"> </div>
<div class="hide"> </div>
<p class="h2f"><span class="right_1" epub:type="pagebreak" id="page_xv" title="xv"><a href="#/text/9780253037756_Contents#abb">Abbreviations</a></span></p>
<table>
<tbody><tr>
<td style="width:15%"><p class="tab">CDU</p></td>
<td style="width:85%"><p class="tab">Christlich Demokratische Union Deutschlands / Christian Democratic Union of Germany</p></td>
</tr>
<tr>
<td><p class="tab">CSU</p></td>
<td><p class="tab">Christlich-Soziale Union in Bayern / Christian Social Union in Bavaria</p></td>
</tr>
<tr>
<td><p class="tab">DPs</p></td>
<td><p class="tab">Displaced Persons</p></td>
</tr>
<tr>
<td><p class="tab">FDP</p></td>
<td><p class="tab">Freie Demokratische Partei / Free Democratic Party</p></td>
</tr>
<tr>
<td><p class="tab">FRG</p></td>
<td><p class="tab">Federal Republic of Germany</p></td>
</tr>
<tr>
<td><p class="tab">GDR</p></td>
<td><p class="tab">German Democratic Republic</p></td>
</tr>
<tr>
<td><p class="tab">HNO</p></td>
<td><p class="tab">Hrvatski Narodni Odbor / Croatian National Committee</p></td>
</tr>
<tr>
<td><p class="tab">HOP</p></td>
<td><p class="tab">Hrvatski Oslobodilački Pokret / Croatian Liberation Movement</p></td>
</tr>
<tr>
<td><p class="tab">IRO</p></td>
<td><p class="tab">International Refugee Organization</p></td>
</tr>
<tr>
<td><p class="tab">NDH</p></td>
<td><p class="tab">Nezavisna Država Hrvatska / Independent State of Croatia</p></td>
</tr>
<tr>
<td><p class="tab">SPD</p></td>
<td><p class="tab">Sozialdemokratische Partei Deutschlands / Social Democratic Party of Germany</p></td>
</tr>
<tr>
<td><p class="tab">UDBA</p></td>
<td><p class="tab">Uprava Državne Bezbednosti / State Security Administration</p></td>
</tr>
<tr>
<td><p class="tab">UHNj</p></td>
<td><p class="tab">Ujedinjeni Hrvati Njemačke / United Croats of Germany</p></td>
</tr>
<tr>
<td><p class="tab">UNHCR</p></td>
<td><p class="tab">United Nations High Commissioner for Refugees</p></td>
</tr>
<tr>
<td><p class="tab">UNRRA</p></td>
<td><p class="tab">United Nations Relief and Rehabilitation Administration<span class="right_1" epub:type="pagebreak" id="page_xvi" title="xvi"></span></p></td>
</tr>
</tbody></table>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253037756_Abbreviations.vue?52e74d7a